import type { IntlShape } from 'react-intl'

import type { SliteBackgroundColor } from '../../components/SlitePage'

export function getTemplateColorFromRemote(
  color: string
): SliteBackgroundColor {
  switch (color) {
    case 'orange':
    case 'saturn-orange':
      return 'slite-orange-300'
    case 'pink':
    case 'pink-moon':
      return 'slite-pink-300'
    case 'blue':
    case 'neptune-blue':
      return 'slite-blue-300'
    default:
      return 'moon-dust-darker'
  }
}

export function getTemplateCategories(intl: IntlShape) {
  return [
    {
      value: 'all',
      title: intl.formatMessage({
        id: 'templateCategory.all',
        defaultMessage: 'All',
      }),
    },
    {
      value: 'informationTechnology',
      title: intl.formatMessage({
        id: 'templateCategory.informationTechnology',
        defaultMessage: 'Information Technology',
      }),
    },
    {
      value: 'operations',
      title: intl.formatMessage({
        id: 'templateCategory.operations',
        defaultMessage: 'Operations',
      }),
    },
    {
      value: 'customerSuccess',
      title: intl.formatMessage({
        id: 'templateCategory.customerSuccess',
        defaultMessage: 'Customer Success',
      }),
    },
    {
      value: 'design',
      title: intl.formatMessage({
        id: 'templateCategory.design',
        defaultMessage: 'Design',
      }),
    },
    {
      value: 'product',
      title: intl.formatMessage({
        id: 'templateCategory.product',
        defaultMessage: 'Product',
      }),
    },
    {
      value: 'sales',
      title: intl.formatMessage({
        id: 'templateCategory.sales',
        defaultMessage: 'Sales',
      }),
    },
    {
      value: 'marketing',
      title: intl.formatMessage({
        id: 'templateCategory.marketing',
        defaultMessage: 'Marketing',
      }),
    },
    {
      value: 'engineering',
      title: intl.formatMessage({
        id: 'templateCategory.engineering',
        defaultMessage: 'Engineering',
      }),
    },
    {
      value: 'humanResources',
      title: intl.formatMessage({
        id: 'templateCategory.humanResources',
        defaultMessage: 'Human Resources',
      }),
    },
    {
      value: 'programAndProjectManagement',
      title: intl.formatMessage({
        id: 'templateCategory.programAndProjectManagement',
        defaultMessage: 'Program & Project Management',
      }),
    },
    {
      value: 'leadership',
      title: intl.formatMessage({
        id: 'templateCategory.leadership',
        defaultMessage: 'Leadership',
      }),
    },
    {
      value: 'customerSupport',
      title: intl.formatMessage({
        id: 'templateCategory.customerSupport',
        defaultMessage: 'Customer Support',
      }),
    },
  ]
}
